import { Info } from "components/icon/Info";
import { useTranslation } from "react-i18next";
import { Text } from "components/text";

export function ContactUsSuccess() {
  const { t } = useTranslation(["contactUs"]);

  return (
    <div className="w-full min-h-[50vh] pt-24 flex justify-center items-center">
      <div className="pb-4 flex flex-col items-center text-center gap-6 max-w-lg">
        <div className="mb-4">
          <Info className="h-12 w-12 p-3" />
        </div>

        <Text variant="pageHeading" className="pb-1">
          {t("success.title")}
        </Text>

        <Text variant="subtle">{t("success.description")}</Text>
      </div>
    </div>
  );
}
